import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { FormatSecondsPipeModule } from 'src/app/pipes/format-seconds/format-seconds-pipe.module';
import { DeleteExtensionDialogComponent } from './delete-extension-dialog.component';

@NgModule({
   declarations: [DeleteExtensionDialogComponent],
   imports: [
      CommonModule,
      MatDialogModule,
      MatButtonModule,
      FormatPhoneNumbersPipeModule,
      FormatSecondsPipeModule,
      LcsResponsiveTableModule,
   ],
})
export class DeleteExtensionDialogModule {}